import { useEffect, useState } from "react";

// globalHistory class is a placeholder for the @reach/router globalHistory module.
// TODO: replace the globalHistory class with the right module.
class globalHistory {
  static listen: (...args: any[]) => () => void;
  static location: any;
  static navigate: any;
}

const useLocation = () => {
  const initialState = {
    location: globalHistory.location,
    navigate: globalHistory.navigate,
  };

  const [state, setState] = useState(initialState);
  useEffect(() => {
    const removeListener = globalHistory.listen((params: any) => {
      const { location } = params;
      const newState = Object.assign({}, initialState, { location });
      setState(newState);
    });
    return () => {
      removeListener();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return state;
};

export default useLocation;
